import {
  Component,
  forwardRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface TabFilterOption<T = unknown> {
  label: string;
  value: T;
}

@Component({
  selector: 'app-tab-filter-group',
  templateUrl: './tab-filter-group.component.html',
  styleUrls: ['./tab-filter-group.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TabFilterGroupComponent),
      multi: true,
    },
  ],
})
export class TabFilterGroupComponent<T = unknown>
  implements ControlValueAccessor, OnChanges
{
  @Input() options: TabFilterOption<T>[] = [];
  @Input() value: T;

  selectedValue: T;

  private onChangeFn: (value: T) => void = () => {};
  private onTouchedFn: () => void = () => {};

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.selectedValue = changes['value'].currentValue;
    }
  }

  onToggleChange(value: T) {
    this.selectedValue = value;
    this.onChangeFn(value);
    this.onTouchedFn();
  }

  writeValue(value: T) {
    this.selectedValue = value;
  }

  registerOnChange(fn: (value: T) => void) {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouchedFn = fn;
  }
}
